import { buildCountsKey, buildDiscussionKey } from "./helpers";

const DEFAULT_DISCUSSION = {
  itemLabel: "",
  commentCount: 0,
  threads: [],
  isLoading: false,
  error: null,
};

const DEFAULT_COUNTS_MAP = {};

export const selectDiscussion = (surface, containerId, itemRef) => (state) =>
  state.comments.discussions[
    buildDiscussionKey(surface, containerId, itemRef)
  ] ?? DEFAULT_DISCUSSION;

export const selectCountsMap = (surface, containerId) => (state) =>
  state.comments.counts[buildCountsKey(surface, containerId)] ??
  DEFAULT_COUNTS_MAP;

export const selectMentionCandidates = (state) =>
  state.comments.mentionCandidates;

export const selectIsMentionCandidatesLoading = (state) =>
  state.comments.isMentionCandidatesLoading;
